import { Material } from '@/app/entities/Material'
import { MaterialCard } from './MaterialCard'
import { useMemo } from 'react'
import {
  getFormattedWeekDate,
  groupMaterialsByWeek,
} from '../MaterialPage/helper'
interface MaterialsListProps {
  materials: Material[]
  onSelectMaterial: (material: Material) => void
  selectedMaterial: Material | null
}

export const sortMaterialsByDate = (materials: Material[]) => {
  return materials.sort(
    (a, b) =>
      new Date(a.dateLiberation).getTime() -
      new Date(b.dateLiberation).getTime(),
  )
}

export const MaterialsList = ({
  materials,
  onSelectMaterial,
  selectedMaterial,
}: MaterialsListProps) => {
  const materialsByWeek = useMemo(
    () => groupMaterialsByWeek(materials ?? []),
    [materials],
  )

  return (
    <div className="flex w-full flex-col gap-4">
      <div>
        {Object.entries(materialsByWeek)
          .sort((a, b) => +b[0] - +a[0])
          .map(([week, materials]) => (
            <div className="mb-4 flex flex-col gap-4" key={week}>
              <h2 className="text-lg font-semibold ">
                Semana de{' '}
                <span className="font-bold">
                  {getFormattedWeekDate(+week, 'start')}
                </span>
                {' à '}
                <span className="font-bold">
                  {getFormattedWeekDate(+week, 'end')}
                </span>
              </h2>
              <ul className="flex flex-row flex-wrap gap-6">
                {materials.map((material) => (
                  <MaterialCard
                    key={material?._id}
                    material={material}
                    onSelectMaterial={onSelectMaterial}
                    isSelected={selectedMaterial?._id === material?._id}
                  />
                ))}
              </ul>
            </div>
          ))}
      </div>
    </div>
  )
}
